import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { JobsProvider } from './contexts/JobsContext';
import { ThemeModeProvider } from './contexts/ThemeModeContext';
import { ToastProvider } from './contexts/ToastContext';
import { AuthProvider } from './contexts/AuthContext';
import { LanguageProvider } from './contexts/LanguageContext';
import { FirstAdminGuard } from './components/FirstAdminGuard'; 
import { CookieConsent } from './components/CookieConsent';
import { CreateFirstAdmin } from './pages/CreateFirstAdmin';
import { Login } from './pages/Login';
import { PrivacyPolicy } from './pages/PrivacyPolicy';
import { CookiePolicy } from './pages/CookiePolicy';
import { AdminUsers } from './pages/AdminUsers';
import { EnsayosPage } from './pages/EnsayosPage';
import { EnsayoDetailPage } from './pages/EnsayoDetailPage';
import { FOSSensorsPage } from './pages/FOSSensorsPage';
import { Profile } from './pages/Profile';
import { ResetPassword } from './pages/ResetPassword';

function App() {
  return (
    <ThemeModeProvider>
      <ToastProvider>
        <BrowserRouter>
          <AuthProvider>
            <LanguageProvider>
              <JobsProvider>
              <FirstAdminGuard>
                <CookieConsent />
                <Routes>
                  <Route path="/create-first-admin" element={<CreateFirstAdmin />} />
                  <Route path="/login" element={<Login />} />
                  {/* <Route path="/register" element={<Register />} /> - Ruta eliminada */}
                  <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                  <Route path="/cookie-policy" element={<CookiePolicy />} />
                  <Route path="/admin/users" element={<AdminUsers />} />
                  <Route path="/ensayos" element={<EnsayosPage />} />
                  <Route path="/ensayos/:id" element={<EnsayoDetailPage />} />
                  <Route path="/fos-sensors" element={<FOSSensorsPage />} />
                  <Route path="/profile" element={<Profile />} />
                  <Route path="/reset-password" element={<ResetPassword />} />
                  <Route path="/" element={<Navigate to="/ensayos" replace />} />
                </Routes>
              </FirstAdminGuard>
              </JobsProvider>
            </LanguageProvider>
          </AuthProvider>
        </BrowserRouter>
      </ToastProvider>
    </ThemeModeProvider>
  );
}

export default App;
